import React, { useState, useEffect } from 'react'


const rowClick = ({event, rowId, globalContext}) => {

	window.location = globalContext.rowClickUrlToProjectSystematicReviews + rowId;

}


export {
	rowClick
}